<script lang="ts">
    import PetitionEmptyStateIcon from '../../icons/PetitionEmptyStateIcon.svelte';
    import * as t from '../../translations/Petitions.ts';
</script>

<div class="flex flex-col items-center justify-center text-center px-4 py-12 text-gray-600" data-testid="petitions-empty-state">
    <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-6">
        <PetitionEmptyStateIcon width="40" height="40" color="#0f766e" />
    </div>
    <h2 class="!text-xl !leading-7 !font-semibold !text-gray-800">{t.No_Petitions_Message()}</h2>
    <p class="mt-2 !text-sm !leading-6 !text-gray-500">{t.No_Petitions_Description()}</p>
</div>
